/**
 * Labstep
 *
 * @module constants/email
 * @desc List of static emails
 */

export const MAILTO_SUPPORT_LABSTEP = 'mailto:hello@labstep.com';
